/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';

import { serverLogger } from 'utils/serverLogger';

// Browser logger implementation
const browserLogger = {
  info: (message, ...args) => {
    console.log(message, { ...args });
    datadogLogs.logger.info(message, { ...args });
  },
  warn: (message, err = {}, ...args) => {
    console.warn(message, err, { ...args });
    datadogLogs.logger.warn(message, { ...args }, err);
  },
  error: (message, err = {}, ...args) => {
    console.error(message, err, { ...args });
    datadogLogs.logger.error(message, { ...args }, err);
  },
};

// Use serverLogger in Node.js environment and browserLogger in browser environment
export const logger = typeof window === 'undefined' ? serverLogger : browserLogger;
